<template>
  <div id="home-wrapper">
    <div class="wrapper">
      <div class="sectionHeader">
        <div :class="headerFixed">
          <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
        </div>
      </div>
      <div class="sectionSearch" id="sectionSearch">
        <div :class="searchFixed">
          <mainSearch class="mainSearch"></mainSearch>
        </div>
      </div>
      <!--banner-->
      <div class="section section1">
        <swiper class="swiperBanner" v-if="bannersData.length >= 1" :options="swiperOptionBanner" ref="swiperBanner">
          <!-- slides -->
          <swiper-slide v-for="(value,index) in bannersData" :key="index">
            <div :class="value.h5_ad_url" :style="{backgroundImage:'url('+value.ad_file+')'}"></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <!--      <div class="section section2">-->
      <!--        <div class="items">-->
      <!--          <div class="item" v-for="(value,index) in homeItems" :key="index" @click="gotoLink(value.link)">-->
      <!--            <img :src="value.image" />-->
      <!--            <br />-->
      <!--            <span>{{value.name}}</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="section section22">
        <div class="items">
          <Row :gutter="5">
            <Col class="item item1" span="6"><img @click="itemClick(0)" src="../assets/icon_hitem1.png" /></Col>
            <Col span="12">
            <Row>
              <Col span="24" class="item item2"><img @click="itemClick(1)" src="../assets/icon_hitem2.png" /></Col>
            </Row>
            <Row :gutter="5">
              <Col span="12" class="item item3"><img @click="itemClick(2)" src="../assets/icon_hitem3.png" /></Col>
              <Col span="12" class="item item4"><img @click="itemClick(3)" src="../assets/icon_hitem4.png" /></Col>
            </Row>
            </Col>
            <Col span="6">
            <Row>
              <Col span="24" class="item item5"><img @click="itemClick(4)" src="../assets/icon_hitem5.png" /></Col>
            </Row>
            <Row>
              <Col span="24" class="item item6"><img @click="itemClick(5)" src="../assets/icon_hitem6.png" /></Col>
            </Row>
            </Col>
          </Row>
          <Row  :gutter="5"  type="flex">
            <Col span="6"  class="item item7"><img @click="itemClick(6)" src="../assets/icon_hitem7.png" /></Col>
            <Col span="6"  class="item item8"><img @click="itemClick(7)" src="../assets/icon_hitem8.png" /></Col>
            <Col span="12"  class="item item8"><img @click="itemClick(8)" src="../assets/icon_hitem9.png" /></Col>
          </Row>
          <!-- <Row :gutter="5">
            <Col span="6" class="item item7"><img @click="itemClick(6)" src="../assets/icon_hitem7.png" /></Col>
            <Col span="6" class="item item8"><img @click="itemClick(7)" src="../assets/icon_hitem8.png" /></Col>
          </Row> -->
        </div>
      </div>
      <!--新人-->
      <div class="section section3" @click="riskClick">
        <img src="../assets/icon-risk.png" />
      </div>
      <!--热门行业-->
      <!--      <div class="section section4">-->
      <!--        <div class="title">热门行业</div>-->
      <!--        <div class="hots-content">-->
      <!--          <div class="hots">-->
      <!--            <div class="hot" v-for="(value,index) in homeHots" :key="index" @click="gotoLink(value.link)">-->
      <!--              <div class="line"></div>-->
      <!--              <img :src="value.image" />-->
      <!--              <br />-->
      <!--              <span>{{value.name}}</span>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--新闻快讯-->
      <div class="section section5">
        <div class="title"></div>
        <div class="news">
          <swiper class="swiperNews" v-if="newsData.length > 1" :options="swiperOptionNews" ref="swiperNews">
            <!-- slides -->
            <swiper-slide class="list" v-for="(value,index) in newsData" :key="index">
              <div @click="gotoNewsinfo(value.id)">{{value.title}}</div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="next"></div>
      </div>
      <!--猜你喜欢-->
      <div class="section section6" id="recommend-header">
        <div :class="recommendHeaderFixed == true ? 'isFixed' :''">
          <div class="swiper-pagination-recommend" slot="pagination">
          </div>
          <div class="more" @click="moreClick">更多 <img src="../assets/icon-next.png" /></div>
        </div>
      </div>
      <div class="section section7" id="section7" ref="section7">
        <div class="content">
          <swiper class="swiperRecommend" :options="swiperOptionRecommend" ref="swiperRecommend">

            <!--            finished-text="我是有底线的"-->
            <swiper-slide class="slideList slideList1">
              <van-list v-model="downLoading" :finished="finished" :immediate-check="false" :offset="20" @load="onLoad">
                <div class="slide1" v-for="(value,index) in recommends" :key="index"
                  @click="gotoGoodsDetail(value.supplier_id, value.id)">
                  <div class="image dimage" v-show="value.product_cover===undefined"></div>
                  <div class="image" v-show="value.product_cover!==undefined"
                    :style="{backgroundImage:'url('+value.product_cover+')'}"></div>
                  <div class="title">
                    <img class="goods-comm-icon" v-if="value.tails.isVipSupplier&&value.tails.isVipSupplier==1" src="https://cdn.zxzx119.com/zxzx-mall-applet/image/ssvip-icon.png" alt="" srcset="">
                    {{value.product_name}}</div>
                  <div class="bottom">
                    <span class="price"
                      v-if="value.tails.telephone_bargain==0"><span>￥</span>{{value.tails.original_price | numFilter}}</span>
                    <span class="phone" v-else>电议</span>
                  </div>
                </div>

              </van-list>
            </swiper-slide>
            <!--            <swiper-slide class="slideList slideList2">-->
            <!--              <div class="slide2" v-for="(value,index) in recommendGoods" :key="index"-->
            <!--                @click="gotoGoodsDetail(value.supplier_id, value.id)">-->
            <!--                <div class="image dimage" v-show="value.product_cover===undefined"></div>-->
            <!--                <div class="image" v-show="value.product_cover!==undefined"-->
            <!--                  :style="{backgroundImage:'url('+value.product_cover+')'}"></div>-->
            <!--                <div class="title">{{value.product_name}}</div>-->
            <!--                <div class="bottom">-->
            <!--                  <span class="price"-->
            <!--                    v-show="!value.tails.telephone_bargain"><span>￥</span>{{value.tails.original_price | numFilter}}</span>-->
            <!--                  <span class="phone" v-show="value.tails.telephone_bargain">电议</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </swiper-slide>-->
            <!--            <swiper-slide class="slideList slideList3">-->
            <!--              <div class="slide3" v-for="(value,index) in recommendBuys" :key="index" @click="gotoBuyInfo(value.id)">-->
            <!--                <div class="title">{{value.title}}</div>-->
            <!--                <div class="tip">采购金额</div>-->
            <!--                <div class="bottom">-->
            <!--                  <span class="address">{{value.province}}</span>-->
            <!--                  <span class="number">&nbsp;&nbsp;{{value.offerCount}}家已报价</span>-->
            <!--                  <span class="moneyTip" v-show="value.total_amount <= 0"><span>暂无</span></span>-->
            <!--                  <span class="money"-->
            <!--                    v-show="value.total_amount > 0"><span>￥</span>{{value.total_amount | numFilter}}</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </swiper-slide>-->
            <!--            <swiper-slide class="slideList slideList4">-->
            <!--              <div class="slide4" v-for="(value,index) in recommendSuppliers" :key="index"-->
            <!--                @click="gotoBusinessInfo(value.tails.merchant_category_id)">-->
            <!--                <div class="image dimage" v-show="value.tails.img===undefined"></div>-->
            <!--                <div class="image" v-show="value.tails.img !== undefined" :style="supplierImage(value.tails.img)"></div>-->
            <!--                <div class="title">{{value.company_name}}</div>-->
            <!--                <div class="product">主营：{{value.tails.merchant_category_name}}</div>-->
            <!--                <div class="bottom">-->
            <!--                  <span class="adress">{{value.province}}</span>-->
            <!--                  <span class="point">&nbsp;&nbsp;{{value.tails.goods}}次被关注</span>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </swiper-slide>-->
          </swiper>
        </div>
      </div>
      <!--合作商-->
      <div class="section section8">
        <div class="partner-content">
          <swiper class="items" v-if="partnerData.length > 1" :options="swiperOptionPartner">
            <swiper-slide v-for="(value,index) in partnerData" :key="index">
              <div class="item">
                <img :src="value.ad_file" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="serve" @click="serverClick()">

      </div>
    </div>
    <AlertView :show="showAlert" title="" :subTitle="alerViewTitle" cancelTitle="取消" :sureTitle="alertSureTitle"
      @alertViewClick="alertViewClick"></AlertView>
    <backTop class="backTop"></backTop>
    <mainFooter class="mainFooter"></mainFooter>
  </div>

</template>

<script>
// import wxShare from '../wx/weixin.js'

import mainHeader from '../view/header'
import mainFooter from '../view/footer'
import mainSearch from '../view/search'
import backTop from '../view/back-top'
import AlertView from '../components/alert-view'
import { Col, Row, List } from 'vant'
// import { Toast } from 'mint-ui'

export default {
  data () {
    const _this = this
    return {
      riseProgress: -1, // 风险 评测进度 -1 未评测  0 评测 初始化 去企业信息  1 去选择场所 2 去答题  3 去评测  4 查看评测结果
      showAlert: false,
      alerViewTitle: '',
      alertSureTitle: '',
      resultId: '', // 评测结果id
      unfinishedCategoryIds: '', // 未答题的id
      imageUrl: this.resourceUrl,
      homeItems: [
        { 'id': '1', 'name': '在线培训', 'image': require('../assets/home-item1.png'), 'link': 'online-training' },
        { 'id': '2', 'name': '在线审图', 'image': require('../assets/home-item2.png'), 'link': 'online-mapping' },
        { 'id': '3', 'name': '应急保障', 'image': require('../assets/home-item3.png'), 'link': 'emergency-support' },
        { 'id': '4', 'name': '专家咨询', 'image': require('../assets/home-item4.png'), 'link': 'ask-question' },
        { 'id': '5', 'name': '安全管家', 'image': require('../assets/home-item5.png'), 'link': 'safe-manager' },
        { 'id': '6', 'name': '企业名录', 'image': require('../assets/home-item6.png'), 'link': 'enterprise-list' },
        { 'id': '7', 'name': '消防百科', 'image': require('../assets/home-item7.png'), 'link': 'news-list' },
        { 'id': '8', 'name': '在线商城', 'image': require('../assets/home-item8.png'), 'link': '/homePage/goodslist?fCids=-1&sCids=-1&tCids=-1' }
      ],
      homeHots: [
        { 'id': '1', 'name': '消防服务', 'image': require('../assets/home-hot1.png'), 'link': '/homePage/goodslist?fCids=230&sCids=-1&tCids=-1' },
        { 'id': '2', 'name': '火灾报警', 'image': require('../assets/home-hot2.png'), 'link': 'https://m.zxzx119.com/homePage/goodslist' },
        { 'id': '3', 'name': '火灾服务', 'image': require('../assets/home-hot3.png'), 'link': 'https://m.zxzx119.com/homePage/goodslist' },
        { 'id': '4', 'name': '灭火设备', 'image': require('../assets/home-hot4.png'), 'link': 'https://m.zxzx119.com/homePage/goodslist' },
        { 'id': '5', 'name': '消防装备', 'image': require('../assets/home-hot5.png'), 'link': 'https://m.zxzx119.com/homePage/goodslist' },
        { 'id': '6', 'name': '智慧消防', 'image': require('../assets/home-hot6.png'), 'link': 'https://m.zxzx119.com/homePage/goodslist' },
        { 'id': '7', 'name': '消防车', 'image': require('../assets/home-hot7.png'), 'link': 'https://m.zxzx119.com/homePage/goodslist' }
      ],
      itemLinks: ['online-training', 'online-mapping', 'enterprise-list', 'news-list', 'ask-question',
        '/homePage/goodslist?fCids=-1&sCids=-1&tCids=-1', 'safe-manager', 'emergency-support', 'microFireHouse'],
      bannersData: [],
      newsData: [],
      partnerData: [],
      recommends: [], // 猜你喜欢
      recommendGoods: [], // 商品
      recommendBuys: [], // 采购
      recommendSuppliers: [], // 供应商
      recommendData: [
        { id: 1, title: '在线商城', list: [] }
        // { id: 1, title: '猜你喜欢', list: [] },
        // { id: 2, title: '商品', list: [] },
        // { id: 3, title: '采购', list: [] },
        // { id: 4, title: '供应商', list: [] }
      ],
      headerFixed: '',
      searchFixed: '',
      recommendHeaderFixed: false,
      downLoading: false,
      finished: false,
      page: 1,
      swiperOptionBanner: {
        direction: 'horizontal',
        loop: true,
        // autoplay: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true,
        initialSlide: 0,
        on: {
          click: function () {
            let item = _this.bannersData[this.realIndex]
            if (item.h5_ad_url === undefined) {
            } else {
              window.location.href = item.h5_ad_url
            }
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOptionNews: {
        direction: 'vertical',
        effect: 'slide',
        loop: true,
        autoplay: true
      },
      swiperOptionRecommend: {
        autoHeight: true,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        initialSlide: 0,
        on: {
          slideChangeTransitionStart: function () {
            // loadMore(this.activeIndex)
          }
        },
        pagination: {// 分页器
          el: '.swiper-pagination-recommend',
          clickable: true,
          renderBullet: function (index, className) {
            // var titles = ['猜你喜欢', '商品', '采购', '供应商']
            // return '<span class="' + className + '">' + titles[index] + '<span></span></span>'
            var titles = ['在线商城']
            return '<span class="' + className + '">' + titles[index] + '</span>'
          }
        },
        fadeeffect: true
      },
      swiperOptionPartner: {
        direction: 'horizontal',
        slidesPerView: 'auto',
        freeMode: true,
        loop: true,
        loopedSlides: 12,
        speed: 2000, // 匀速时间
        autoplay: { // 无缝滚动
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      }

    }
  },
  methods: {
    serverClick () {
      this.YSF.init('1a5d46871ba2e8c628b5a7abe265ef26', {
        templateId: 123, // templateId表示自定义会话邀请的模板标识
        shuntId: 123, // shuntId表示访客选择多入口分流模版id
        sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 1 // hidden表示是否隐藏访客端默认入口
      }).then(ysf => {
        ysf('open')
        // ysf('product', {
        //     show: 1,
        //     title: '任天堂（Nintendo）Switch游戏机',
        //     desc: '任天堂（Nintendo） Switch NS NX掌上游戏机便携 塞尔达马里奥新款游戏机 主机不锁 日版黑机彩色手柄+中文赛/塞尔达传说(指南+地图)',
        //     picture: 'https://img10.360buyimg.com/n5/s75x75_jfs/t4030/290/29851193/293745/d5e2b731/58ac3506Nbb57b5f6.jpg',
        //     note: '￥1978',
        //     url: 'https://www.taobao.com/',
        //     sendByUser: 0
        // })
      }).catch(error => {
        console.log(error)
        console.log('sdk加载失败')
      })
    },
    logoutClick: function () { // 退出登录
      // this.$router.push({path: 'home'})
    },
    supplierImage: function (imgs) {
      //  111
      //   '+imageUrl+value.tails.img.split(',')[0]+'
      console.log('=============img')
      if (imgs == null) {
        return 'backgroundImage:url(../assets/home-news.png)'
      }
      if (imgs.indexOf(',') < 0 && imgs.length > 0) {
        let imgStr = this.imageUrl + imgs
        return 'backgroundImage:url(' + imgStr + ')'
      }
      if (imgs.indexOf(',') >= 0) {
        let imgStr = this.imageUrl + imgs.split(',')[0]
        return 'backgroundImage:url(' + imgStr + ')'
      }

      // return "{backgroundImage:'url(supplierImage(value.tails.img))'}"
    },
    riskClick: function () { // 风险评测
      var _this = this
      // 如果是登陆状态，根据登陆的用户查询评测的基本企业信息
      this.utils.isUserLogin(function (login) {
        console.log('==========' + login)
        if (login === 1) { // 已登录状态  查看用户风险评测进度
          // 风险评测 进度
          _this.questionProgress()
        } else { // 未登录状态 完善评测信息
          _this.$router.push({ path: 'evaluate-company' })
        }
      })
    },
    questionProgress: function () { // 查询 答题 进度采购
      console.log('获取答题进度 ==============================')
      var _this = this
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      console.log(userinfo)
      this.utils.GETHeader(this.accountUrl + '/riskeval/getProgress', { 'phone': userinfo.tails.userinfo[0].phone }, function (response) {
        console.log(response)
        let data = response.data
        if (data === undefined) {
          _this.riseProgress = 0
          _this.$router.push({ path: 'evaluate-company' })
          return
        }
        if (data !== undefined) {
          console.log('评测进度 =====================')
          // progress 0 初始化,提交了企业信息,点击开始评测 未选择场所  1 完成二级答题 2 完成三级答题 3 完成评测 4 完成所有 分类答题
          _this.resultId = data.result_id
          let progress = data.progress
          if (progress === 0) {
            if (data.tails.siteCategoryList !== null && data.tails.siteCategoryList.length > 0) { // 已经选择 分类
              var categoryIds = ''
              for (let i = 0; i < data.tails.siteCategoryList.length; i++) {
                let catItem = data.tails.siteCategoryList[i]
                //  status 1 完成答题 2 未答题
                if (catItem.tails.status === 0) {
                  categoryIds += (catItem.id + ',')
                }
              }
              // 有未完成的分类 答题
              if (categoryIds.length > 0) {
                if (categoryIds.indexOf(',') >= 0) {
                  categoryIds = categoryIds.slice(0, categoryIds.length - 1)
                }
                // 提示有 未完成答题 提示 继续答题
                console.log('有未完成的评测 去完成=====================')
                _this.unfinishedCategoryIds = categoryIds
                _this.riseProgress = 2
                _this.showAlert = true
                _this.alerViewTitle = '您有尚未完成的评测'
                _this.alertSureTitle = '前往完成'
              }
            } else {
              console.log('未选择场所 选择场所=====================')
              _this.showAlert = true
              _this.alerViewTitle = '您有尚未完成的评测'
              _this.alertSureTitle = '前往完成'
              _this.riseProgress = 1
            }
          }
          if (progress === 4) { // 新版 完成所有 分类答题 - 》 跳转风险 评测答题
            console.log('未完成 最后的风险评测 =====================')
            _this.riseProgress = 3
            _this.showAlert = true
            _this.alerViewTitle = '您有尚未完成的评测'
            _this.alertSureTitle = '前往完成'
            return
          }
          // 查看评测结果
          if (progress === 3) {
            // 已经 有评测结果  是否 已满一个月  0 已满 可继续评测  1 未满 查看评测结果
            let repeat = data.tails.repeat
            if (repeat === 0) {
              console.log('已满一个月 重新评测==========' + repeat)
              _this.riseProgress = 0
              // 重新评测
              _this.$router.push({ path: 'evaluate-company' })
            }
            if (repeat === 1) { // 不可评测
              console.log('未满一个月 查看评测结果==========' + repeat)
              // 是否 评测结果 满分
              if (parseInt(data.tails.perfect_status) === 0) { // 0 不完美 1 完美
                _this.alerViewTitle = '每月仅限评测一次，请依据上次评测结果立即整改。'
              } else {
                _this.alerViewTitle = '评测一个月有效，是否查看评测结果？'
              }
              _this.riseProgress = 4
              _this.showAlert = true
              _this.alertSureTitle = '前往查看'
            }
          }
        }
      })
    },
    alertViewClick: function (index) {
      this.showAlert = false
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      console.log('===================================')
      if (index === 1) {
        if (this.riseProgress === 0) {
          this.$router.push({ path: 'evaluate-company' })
        }
        if (this.riseProgress === 1) {
          this.$router.push({ path: 'evaluate-category2' })
        }
        if (this.riseProgress === 2) {
          this.$router.push({ path: 'fxcp_changsuo', query: { phoneNumber: userinfo.tails.userinfo[0].phone } })
          // this.$router.push({path: 'evaluate-question', query: {categoryIds: this.unfinishedCategoryIds}})
        }
        if (this.riseProgress === 3) {
          this.$router.push({ path: 'fxcp_changsuo', query: { phoneNumber: userinfo.tails.userinfo[0].phone } })
          // this.$router.push({ path: 'evaluate-question-risk' })
        }
        if (this.riseProgress === 4) {
          this.$router.push({ path: 'fxcp_result', query: { resultId: this.resultId } })
        }
      }
    },
    gotoLink: function (link) { // 热门行业
      if (link.indexOf('http') >= 0) {
        window.location.href = link
      } else {
        this.$router.push({ path: link })
      }
    },
    itemClick: function (type) {
      this.$router.push({ path: this.itemLinks[type] })
    },
    moreClick: function () {
      let index = this.$refs.swiperRecommend.swiper.activeIndex
      if (index === 0 || index === 1) {
        this.$router.push({
          path: '/homePage/goodslist',
          query: {
            fCids: -1,
            sCids: -1,
            tCids: -1
          }
        })
        // window.location.href = 'https://m.zxzx119.com/homePage/goodslist'
      }
      if (index === 2) {
        window.location.href = 'http://www.zxzx119.com/buysearch'
      }
      if (index === 3) {
        window.location.href = 'http://www.zxzx119.com/ListEnterprises'
      }
    },
    gotoNewsinfo: function (id) { // 百科详情
      this.$router.push({ path: 'news-info', query: { newsID: id } })
    },
    gotoGoodsDetail: function (supplierid, id) { // 商品详情 http://www.zxzx119.com/goodsdetail/16397?id=2579
      this.$router.push({
        path: '/goodsdetail',
        query: {
          businessId: supplierid,
          goodsId: id
        }
      })
      // window.location.href = 'http://www.zxzx119.com/goodsdetail/?' + supplierid + '?id=' + id
    },
    gotoBuyInfo: function (id) { // 采购信息 http://www.zxzx119.com/shoplist?id=355
      window.location.href = 'http://www.zxzx119.com/shoplist?id=' + id
    },
    gotoBusinessInfo: function (id) { // 供应商 http://www.zxzx119.com/ListEnterprises?key=1
      // window.location.href = 'http://www.zxzx119.com/ListEnterprises?key=' + id
      window.location.href = 'http://www.zxzx119.com/listxq/' + id
    },
    loadData () {
      // 获取banner图
      this.utils.GET(this.accountUrl + '/adb/getList?type=66', data => {
        this.bannersData = data.data
        if (this.bannersData.length < 2) {
          this.swiperOptionBanner.pagination.el = null
        }
      })
      this.utils.GET(this.accountUrl + '/adb/getList?type=112', data => {
        this.partnerData = []
        this.partnerData = data.data
        console.log(this.partnerData)
      })

      // 获取 热点新闻数据
      this.utils.GET(this.accountUrl + '/jpressContent/list?pageNo=1&pageSize=6&taxonomyIds=5', data => {
        this.newsData = data.data.rows
      })
      // 合作伙伴 图标 http://cdn.zxzx119.com/
      // http://www.zxzx119.com/account/supplier/list?index=1
      // this.utils.GET(this.accountUrl + '/supplier/list?index=1', data => {
      //   this.partnerData = data.data.rows
      // })
    },
    loadRecommend: function (type) { // 获取 推荐数据
      var _this = this
      // 猜你喜欢
      this.utils.GET(this.accountUrl + '/goods/goodsList?rows=10&orderType=1&page=' + this.page,
        function (data) {
          if (_this.page === 1) {
            _this.recommends = []
          }
          let datas = data.data.rows
          _this.recommends = _this.recommends.concat(datas)

          _this.upLoading = false
          _this.downLoading = false
          if (_this.recommends.length === data.data.records) {
            _this.finished = true
          }

          // _this.recommends = data.data.rows
        })
      // // 商品
      // this.utils.GET(this.accountUrl + '/goods/goodsList?page=1&rows=10&orderType=1',
      //   function (data) {
      //     _this.recommendGoods = data.data.rows
      //   })
      // // 采购 http://www.zxzx119.com/account/wantBuy/wantBuyList2?page=1&rows=10
      // this.utils.GET(this.accountUrl + '/wantBuy/wantBuyList?page=1&rows=10',
      //   function (data) {
      //     _this.recommendBuys = data.data.rows
      //   })
      //
      // // 供应商 http://www.zxzx119.com/account/supplier/list?page=1&words=1&type=&order=desc
      // this.utils.GET(this.accountUrl + '/supplier/list?page=1',
      //   function (data) {
      //     _this.recommendSuppliers = data.data.rows
      //   })
    },
    handleScroll: function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // console.log('handleScroll===' + scrollTop)
      var offsetTop = document.getElementById('recommend-header').offsetTop

      // console.log('offsetTop---' + offsetTop)
      // 推荐
      if (scrollTop >= (offsetTop - 50)) {
        this.recommendHeaderFixed = true
      } else {
        this.recommendHeaderFixed = false
      }

      // 搜索
      if (scrollTop > 0 && scrollTop < 210) {
        this.searchFixed = 'isFixed'
      } else if (scrollTop >= 210) {
        this.searchFixed = 'isHeaderFixed'
      } else {
        this.searchFixed = ''
      }

      // 头部
      if (scrollTop < 210) {
        this.headerFixed = 'isFixed'
      } else {
        this.headerFixed = ''
      }
    },
    onLoad: function () {
      this.page++
      // console(this.page)
      this.loadRecommend(2)
    },
    binBack: function () { // 禁止后退
      // history.pushState(null, null, document.URL)
      // window.addEventListener('popstate', function () {
      //   history.pushState(null, null, document.URL)
      // })
    }
  },
  components: { // 注册组件
    mainHeader,
    mainFooter,
    mainSearch,
    backTop,
    AlertView,
    Col,
    Row,
    List
  },
  watch: { // 监测
    $router () {
    }
  },
  filters: {
    numFilter (value) {
      // 截取当前数据到小数点后两位
      // let realVal = parseFloat(value * 0.01).toFixed(2)
      // return realVal
      var val = parseFloat(value * 0.01).toFixed(2)

      var intPart = Number(val) | 0 // 获取整数部分
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断

      var floatPart = '.00' // 预定义小数部分
      var value2Array = val.split('.')

      // =2表示数据有小数位
      if (value2Array.length === 2) {
        floatPart = value2Array[1].toString() // 拿到小数部分

        if (floatPart.length === 1) { // 补0,实际上用不着
          return intPartFormat + '.' + floatPart + '0'
        } else {
          return intPartFormat + '.' + floatPart
        }
      } else {
        return intPartFormat + floatPart
      }
    }
  },
  mounted () {
    // 微信 分享
    // wxShare.wxRegister('招募消防专家','只要你够专业，即可成为中消消防专家组成员','http://cdn.zxzx119.com/1759303530708992')
    // document.getElementById('section7').style.height = window.screen.height - 110
    // setTimeout(function () {
    //   console.log('0000=====' + document.getElementById('section7').height)
    // }, 3000)
    this.loadData()
    this.loadRecommend(2)
    this.binBack()

    // 监听滑动
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }

}

</script>

<style scoped="scoped">
#home-wrapper {
  background-color: #f1f1f1;
  width: 100%;
  height: 100%;
  /*height: calc(100% + 800px);*/
}
 .goods-comm-icon{
      width: 45px;
      height: 13px;
      margin-right: 5px;
    }
.serve {
  position: fixed;
  width: 35px;
  height: 35px;
  background: url("../assets/contact.png") no-repeat center center;
  background-size: cover;
  border-radius: 50%;
  bottom: 180px;
  right: 15px;
  z-index: 999;
}
.wrapper {
  position: relative;
  width: 100%;
}

.section {
  position: relative;
  /*width: 100%;*/
  /*border: solid 1px red;
  box-sizing: border-box;*/
}
.section2,
.section22,
.section3,
.section4,
.section5 {
  margin-bottom: 10px;
}
.sectionHeader {
  height: 55px;
  width: 100%;
  z-index: 900;
}
.sectionHeader .isFixed {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 900;
}
.sectionSearch {
  height: 50px;
  /*background-color: yellowgreen;*/
}
.sectionSearch .isFixed {
  position: fixed;
  top: 55px;
  width: 100%;
  height: 50px;
  z-index: 950;
}
.sectionSearch .isHeaderFixed {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 50px;
  /*阴影*/
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);

  z-index: 950;
}
.section1 {
  /*position: absolute;*/
  /*top: 105px;*/
  /*width: 100%;*/
  height: 160px;
  background-color: #f9f9f9;
}
.section1 .swiperBanner {
  width: 100%;
  height: 160px;
  overflow: hidden;
}
.section1 .swiperBanner div {
  height: 160px;
  width: 100%;
  /*background-image: url(../assets/home-news.png);*/
  background-size: cover;
  background-position: center center;
}
>>> .section1 .swiper-pagination {
  position: absolute;
  top: 135px;
  height: 25px;
  width: 100%;
}
>>> .section1 .swiper-pagination .swiper-pagination-bullet {
  /*width: 8px;*/
  /*height: 8px;*/
  margin-left: 6px;
  background: #ffffff;
  opacity: 1;
}

>>> .section1 .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #c41335;
}
.section2 {
  height: 195px;
  background-color: #ffffff;
}
.section2 .items {
  position: absolute;
  margin-top: 15px;
  width: 100%;
}
.section2 .items .item {
  float: left;
  width: 25%;
  height: 90px;
  text-align: center;
}
.section2 .items .item img {
  width: 45px;
  height: 45px;
}
.section2 .items .item span {
  color: #323232;
  font-size: 14px;
}
.section22 {
  min-height: 50px;
  /*background-color: #ffffff;*/
}
.section22 .items {
  margin: 15px 15px 0 15px;
  width: calc(100% - 30px);
  line-height: 0px;
}
.section22 .items .item img {
  width: 100%;
  height: 100%;
}
.section22 .items .item3,
.item4,
.item6,
.item7,
.item8 {
  margin-top: 5px;
}

.section3 {
  /*position: absolute;*/
  /*top: 460px;*/
  /*width: 100%;*/
  /*height: 100px;*/

  background-color: #f1f1f1;
  text-align: center;
}
.section3 img {
  width: 94%;
}
.section4 {
  /*position: absolute;*/
  /*top: 560px;*/
  /*width: 100%;*/
  height: 130px;
  background-color: #ffffff;
}
.section4 .title {
  position: absolute;
  height: 40px;
  line-height: 40px;
  left: 15px;
  color: #000000;
  font-size: 17px;
  font-weight: bold;
}
.section4 .hots-content {
  position: absolute;
  top: 45px;
  height: 70px;
  width: 100%;
  overflow: auto;
}
.section4 .hots-content .hots {
  width: 630px;
  height: 70px;
}
.section4 .hots-content .hots .hot {
  position: relative;
  float: left;
  width: 90px;
  height: 70px;
  text-align: center;

  /*border: solid 1px blueviolet;
  box-sizing: border-box;*/
}
.section4 .hots-content .hots .hot img {
  position: absolute;
  top: 0px;
  left: 27px;
  width: 35px;
  height: 35px;
}
.section4 .hots-content .hots .hot span {
  position: absolute;
  top: 35px;
  left: 0px;
  width: 90px;
  color: #323232;
  font-size: 14px;
  text-align: center;
}
.section4 .hots-content .hots .hot .line {
  position: absolute;
  left: 88px;
  top: 20px;
  width: 2px;
  height: 20px;
  background-color: #eeeeee;
}
.section5 {
  /*position: absolute;*/
  /*top: 690px;*/
  /*width: 100%;*/
  height: 40px;
  background-color: #ffffff;
}
.section5 .title {
  position: absolute;
  top: 12px;
  left: 15px;
  height: 15.5px;
  width: 82px;
  background-image: url(../assets/home-news.png);
  background-size: cover;
  background-position: center center;
}
.section5 .next {
  position: absolute;
  top: 15px;
  right: 10px;
  height: 10px;
  width: 6px;
  background-image: url(../assets/icon-next.png);
  background-size: cover;
  background-position: center center;
}
.section5 .news {
  position: absolute;
  top: 0px;
  left: 110px;
  right: 30px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  /*background-color: #FF0000;*/
}
.section5 .news .swiperNews {
  position: relative;
  height: 40px;
  overflow: hidden;
}
.section5 .news .swiperNews .list {
}
.section5 .news .swiperNews div {
  text-align: left;
  font-size: 13px;
  color: #323232;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.section6 {
  /*position: absolute;*/
  /*top: 730px;*/
  /*width: 100%;*/
  height: 50px;
  background-color: #f9f9f9;
}
.section6 .isFixed {
  position: fixed;
  top: 50px;
  width: 100%;
  height: 50px;
  background-color: #f9f9f9;
  z-index: 700;
}
.section6 .swiper-pagination-recommend {
  position: relative;
  top: 0px;
  width: 100%;
  height: 50px;
  background-color: #ffffff;

  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
}
.section6 .more {
  position: absolute;
  top: 0px;
  right: 15px;
  height: 50px;
  line-height: 50px;
  font-size: 12px;
  color: #999999;
}
.section6 .more img {
  width: 6px;
  height: 10px;
}
.section7 {
  border-bottom: solid 15px #f9f9f9;
  /*position: absolute;*/
  /*top: 780px;*/
  /*width: 100%;*/
  /*height: 80%;*/
  background-color: #ffffff;
  /*position: relative;*/
  /*height: auto;*/
  /*height: 500px;*/
  /*background-color: yellow;*/
  /*height: 500px;*/
  /*overflow: hidden;*/
}
.section7 .content {
  height: auto;
}
/*.slideList{*/
/*  overflow: hidden;*/
/*  background-color: #FFFFFF;*/
/*min-height: 1px;*/
/*  max-height: 100%;*/
/*}*/

.dimage {
  background-image: url("../assets/icon-product.jpg");
  background-size: cover;
  background-position: center center;
}
.vant-list {
  width: 100%;
}
.slideList1 {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  /*border-bottom: solid 15px #f9f9f9;*/
  padding-bottom: 15px;
}
.slideList1 .slide1 {
  position: relative;
  float: left;
  margin-top: 10px;
  margin-left: 15px;
  width: calc((100% - 45px) / 2);
  height: 250px;
  background-color: #f9f9f9;

  border-radius: 6px;
  background-color: #f7f7f7;

  border: #eeeeee solid 1px;
  box-sizing: border-box;

  /*background-color: yellow;*/
}
.slideList1 .slide1 .image {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 165px;
  background-color: #f9f9f9;
  /*background-image: url(../assets/icon_new_default.png);*/
  background-size: cover;
  background-position: center center;

  border-radius: 6px 6px 0 0;
  box-sizing: border-box;
}
.slideList1 .slide1 .title {
  position: absolute;
  top: 170px;
  left: 10px;
  right: 10px;
  height: 40px;
  line-height: 20px;
  color: #000000;
  font-size: 15px;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.slideList1 .slide1 .bottom {
  position: absolute;
  top: 220px;
  left: 10px;
  right: 10px;
  height: 20px;
  line-height: 20px;
  color: #333333;
  font-size: 12px;
}
.slideList1 .slide1 .bottom .price {
  color: #c41335;
  font-size: 16px;
  font-weight: bold;
}
.slideList1 .slide1 .bottom .price span {
  color: #c41335;
  font-size: 13px;
  font-weight: normal;
}
.slideList1 .slide1 .bottom .phone {
  color: #c41335;
  font-size: 16px;
  font-weight: bold;
}

.slideList2 .slide2 {
  position: relative;
  float: left;
  margin-top: 10px;
  margin-left: 15px;
  width: calc((100% - 45px) / 2);
  height: 250px;

  border-radius: 6px;
  background-color: #f7f7f7;

  border: #eeeeee solid 1px;
  box-sizing: border-box;
}
.slideList2 .slide2 .image {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 165px;
  background-color: #f9f9f9;
  /*background-image: url(../assets/icon_new_default.png);*/
  background-size: cover;
  background-position: center center;

  border-radius: 6px 6px 0 0;
  box-sizing: border-box;
}
.slideList2 .slide2 .title {
  position: absolute;
  top: 170px;
  left: 10px;
  right: 10px;
  height: 40px;
  line-height: 20px;
  color: #000000;
  font-size: 15px;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.slideList2 .slide2 .bottom {
  position: absolute;
  top: 220px;
  left: 10px;
  right: 10px;
  height: 20px;
  line-height: 20px;
  color: #333333;
  font-size: 12px;
}
.slideList2 .slide2 .bottom .price {
  color: #c41335;
  font-size: 16px;
  font-weight: bold;
}
.slideList2 .slide2 .bottom .price span {
  color: #c41335;
  font-size: 13px;
  font-weight: normal;
}
.slideList2 .slide2 .bottom .phone {
  color: #c41335;
  font-size: 16px;
  font-weight: bold;
}

.slideList3 .slide3 {
  position: relative;
  width: 100%;
  height: 75px;
  background-color: #ffffff;

  border-bottom: #eeeeee solid 1px;
  box-sizing: border-box;
}
.slideList3 .slide3 .title {
  position: absolute;
  top: 10px;
  left: 15px;
  right: 80px;
  height: 30px;
  line-height: 30px;
  color: #000000;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.slideList3 .slide3 .tip {
  position: absolute;
  top: 10px;
  right: 15px;
  height: 30px;
  line-height: 30px;
  color: #999999;
  font-size: 13px;
}

.slideList3 .slide3 .bottom {
  position: absolute;
  left: 15px;
  right: 15px;
  top: 45px;
  height: 20px;
  line-height: 20px;
  color: #999999;
  font-size: 12px;
}
.slideList3 .slide3 .bottom .address {
}
.slideList3 .slide3 .bottom .number {
  left: 20px;
}
.slideList3 .slide3 .bottom .moneyTip {
  float: right;
  color: #c41335;
  font-size: 16px;
  font-size: 13px;
  font-weight: normal;
  color: #999999;
}
.slideList3 .slide3 .bottom .money {
  float: right;
  color: #c41335;
  font-size: 16px;
  font-weight: bold;
}
.slideList3 .slide3 .bottom .money span {
  font-size: 13px;
  font-weight: normal;
}
.slideList4 .slide4 {
  position: relative;
  width: 100%;
  height: 105px;
  background-color: #ffffff;

  border-bottom: #eeeeee solid 1px;
  box-sizing: border-box;
}
.slideList4 .slide4 .image {
  position: absolute;
  top: 20px;
  left: 15px;
  width: 65px;
  height: 65px;
  background-color: #f9f9f9;
  /*background-image: url(../assets/icon_new_default.png);*/
  background-size: cover;
  background-position: center center;
}
.slideList4 .slide4 .title {
  position: absolute;
  top: 20px;
  left: 90px;
  right: 15px;
  height: 20px;
  line-height: 20px;
  color: #000000;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.slideList4 .slide4 .product {
  position: absolute;
  top: 45px;
  left: 90px;
  right: 15px;
  height: 15px;
  line-height: 15px;
  color: #333333;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.slideList4 .slide4 .bottom {
  position: absolute;
  left: 90px;
  right: 15px;
  top: 65px;
  height: 20px;
  line-height: 20px;
  color: #999999;
  font-size: 12px;
}
.slideList4 .slide4 .address {
}
.slideList4 .slide4 .point {
  left: 20px;
}

.section8 {
  height: 50px;
  background-color: #ffffff;
}
.section8 .partner-content {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 50px;
}
.section8 .partner-content .items {
  width: 100%;
  height: 50px;
}
/*设置匀速无缝滚动*/
>>> .section8 .swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
>>> .section8 .partner-content .swiper-slide {
  width: 100px !important;
}
.section8 .partner-content .items .item {
  width: 100px;
  height: 100px;
}
.section8 .partner-content .items .item img {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 70px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue